type ErrorMessageProps = {
  message?: string;
};

/**
 * Renders an error message in a red box
 */
function ErrorMessage(props: ErrorMessageProps) {
  if (!props.message) {
    return null;
  }

  return (
    <div className="mb-6 p-4 text-sm bg-intent-error-3 text-intent-error-5 border-intent-error-2 border-1 rounded-lg">
      {props.message}
    </div>
  );
}

export default ErrorMessage;
